<!--
 © 2025 nSide, Inc. All Rights Reserved.
 This software and its source code are the confidential and proprietary
 information of nSide, Inc. (“Confidential Information”). You may not
 use, reproduce, disclose, distribute, modify, or create derivative works
 of this code except in accordance with a written license agreement or
 other written authorization from nSide, Inc.

 Unauthorized use is strictly prohibited and may result in civil and
 criminal penalties.
-->

<style>
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  .animate-spin {
    animation: spin 1s linear infinite;
  }
</style>

<!-- Header -->
<div style="display: flex; flex-direction: row; align-items: flex-start; margin-left: 2vw; margin-top: 2vw; margin-bottom: 0; justify-content: space-between; width: 95%;">
  <div style="display: flex; align-items: center; margin-bottom: 0;">
    <img src="assets/nside-edge-for-light-background.png" alt="Image" style="height: 60px; max-width: 300px; margin-right: 1vw;">
    <span style="font-size: 2.5vw; font-family: 'Oswald', sans-serif; color: #5F6062; letter-spacing: 1px;">DASHBOARD</span>
  </div>
  <!-- History button -->
  <div style="display: flex; align-items: center;">
    <button id="history-btn" title="History" (click)="viewHistory()" style="background: none; border: none; cursor: pointer; display: flex; align-items: center; margin-bottom: -4vw;">
      <i class="fas fa-history" style="font-size: 2vw; color: #5F6062;"></i>
    </button>
  </div>
</div>

<!-- History Modal -->
<div *ngIf="showHistoryModal" id="customHistoryModal" style="display:flex; z-index:9999; position:fixed; inset:0; background:rgba(249,249,249,0.85); align-items:center; justify-content:center;">
  <!-- Modal Content -->
  <div *ngIf="!historyLoading" id="historyModalContent" style="max-height:100vh; width:100vw; display:flex; flex-direction:column; align-items:center; justify-content:center; overflow:hidden;">
    <div style="width:100%; max-width:700px; display:flex; flex-direction:column; margin:1.5vw 0; padding:2vw; background:white; border-radius:12px; box-shadow:0 4px 32px rgba(0,0,0,0.15); overflow:hidden;" (click)="$event.stopPropagation()">
      <div style="width:100%; display:flex; flex-direction:column; align-items:center; justify-content:space-between; padding-bottom:0.5vh;">
        <h2 style="width:100%; font-family:Oswald,sans-serif; font-size:2vw; color:#f15d22;">Action History</h2>
      </div>
      <ol id="customHistoryList" style="height:60vh; overflow-y:auto; position:relative; border-left:2px solid #e5e7eb; margin:0; padding-left:2vw;">
        <li *ngIf="historyRecords.length === 0" style="margin-bottom:1vh; color:#888;">No history records found.</li>
        <li *ngFor="let record of historyRecords" style="margin-bottom:1.0vw; position:relative; padding-left:1.5vw;">
          <div style="position:absolute;left:-2.55vw;top:0.5vh;width:1vw;height:2vh;background:#e5e7eb;border-radius:50%;border:2px solid #fff;"></div>
          <p style="margin-bottom:0.25vh;font-size:1.0vw;color:#222;">{{ formatDate(record.date) }}</p>
          <p style="margin-bottom:0.25vh;font-size:1.0vw;color:#222;"><span style="font-weight:600;">Action:</span> {{ record.description }}</p>
          <p style="margin-bottom:0.25vh;font-size:1.0vw;color:#222;"><span style="font-weight:600;">Door Name:</span> {{ record.door_name }}</p>
          <p style="margin-bottom:0.25vh;font-size:1.0vw;color:#222;"><span style="font-weight:600;">User:</span> {{ record.user_name }}</p>
        </li>
      </ol>
      <div style="margin-top:1vh; display:flex; justify-content:flex-end; gap:1vw;">
        <button (click)="closeHistoryModal()" style="padding:0.4vw 1.5vw; border-radius:6px; border:1px solid #b0b0b0; font-family:Oswald,sans-serif; background:#fff; cursor:pointer;">Close</button>
      </div>
    </div>
  </div>

  <!-- Loading Spinner History -->
  <div *ngIf="historyLoading" id="historyLoadingSpinner" style="display:flex; position:fixed; inset:0; z-index:10000; background:rgba(249,249,249,0.5); align-items:center; justify-content:center;">
    <div class="p-6 rounded-md text-center">
      <div role="status flex flex-col items-center justify-center">
        <div class="w-full flex items-center justify-center">
          <svg aria-hidden="true" width="100" height="100" class="inline animate-spin" style="width:10vw; max-width:160px;" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#edeeef"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#f25d22"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Loading Spinner Dashboard -->
<div *ngIf="dashboardLoading" style="display:flex; position:fixed; inset:0; z-index:10000; background:rgba(249,249,249,0.5); align-items:center; justify-content:center;">
  <div class="p-6 rounded-md text-center">
    <div role="status flex flex-col items-center justify-center">
      <div class="w-full flex items-center justify-center">
        <svg aria-hidden="true" width="100" height="100" class="inline animate-spin" style="width:10vw; max-width:160px;" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#edeeef"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#f25d22"/>
        </svg>
      </div>
    </div>
  </div>
</div>

<div class="dashboard-container" style="display: flex; gap: 2vw; padding: 0 2vw 2vw 2vw;">
  <!-- Left panel: Door details -->
  <div class="door-details" style="flex: 1; background: #fff; border-radius: 12px; box-shadow: 0 4px 16px rgba(0,0,0,0.08); padding: 1vw;">
    <p style="font-size: 2vw; font-family: Raleway; margin-bottom: 0; color: #5F6062;">Door Name: <b>{{ doorName }}</b></p>
    <div id="map-preview" style="flex: 1 1 auto; width: 100%; height: 55vh; margin-left: 0; margin-top: 1vw; margin-bottom: 2vw; min-height: 250px;"></div>
    <div style="display: flex; gap: 1vw; margin-bottom: 0;">
      <button class="live-feed-button" style="flex: 1;" (click)="unlockDoor(featureId)" [disabled]="isUnlocking(featureId)">
        <i class="fa fa-lock-open" style="margin-right: 6px;"></i>{{ isUnlocking(featureId) ? 'UNLOCKING...' : 'UNLOCK DOOR' }}
      </button>
      <button
        *ngIf="selectedDevice?.camera_id && selectedDevice?.featureId"
        class="live-feed-button"
        style="flex: 1;"
        (click)="openCameraFeed()">
        <i class="fa fa-camera" style="margin-right: 6px;"></i>VIEW FEED
      </button>
    </div>
  </div>

  <!-- Right panel: Door table -->
  <div class="door-table" style="flex: 2; background: #fff; border-radius: 12px; box-shadow: 0 4px 16px rgba(0,0,0,0.08); padding: 0vw; overflow-y: auto; max-height: 80vh;">
    <table style="width: 100%; border-collapse: collapse;">
      <thead>
        <tr>
          <th style="text-align: center; font-size: 1.2vw;">DEVICE</th>
          <th style="text-align: center; font-size: 1.2vw;">REMOTE UNLOCK</th>
          <th style="text-align: center; font-size: 1.2vw;">VIEW LIVE FEED</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of tableData">
          <tr>
            <td [class.selected-device]="isSelectedDevice(row.featureId)" style="padding: 1vw 0; font-size: 1vw;">
              <a [routerLink]="['/', row.featureId]" (click)="scrollTableToTop()" style="color: inherit; text-decoration: underline; cursor: pointer;">
                {{ row.textField }}
              </a>
            </td>
            <td style="text-align: center;">
              <button class="live-feed-button" style="width: 80%;" (click)="unlockDoor(row.featureId)" [disabled]="isUnlocking(row.featureId)">{{ isUnlocking(row.featureId) ? 'UNLOCKING...' : 'UNLOCK DOOR' }}</button>
            </td>
            <td style="text-align: center;">
              <button *ngIf="row.camera_id" class="live-feed-button" style="width: 80%;" (click)="viewCamera(row.featureId)">VIEW FEED</button>
            </td>
          </tr>
          <!-- Camera feed row -->
          <tr *ngIf="activeCameraFeatureId === row.featureId && cameraFeedUrl" class="camera-feed-row">
            <td colspan="3" style="padding: 0 0 2vw 0;">
              <div style="position:relative;width:100%;height:600px;">
                <button (click)="closeCameraFeed()" style="position:absolute;top:0;right:0;z-index:10;background:transparent;border:none;padding:0;cursor:pointer;width:32px;height:32px;display:flex;align-items:center;justify-content:center;">
                  <img src="assets/close-colorbox.png" alt="Close" style="width:32px;height:32px;display:block;"/>
                </button>
                <iframe [src]="cameraFeedUrl | sanitizeUrl" style="width:100%;height:100%;border:none;" allowfullscreen></iframe>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
